import React from "react"
import { motion, AnimatePresence, useAnimation } from "framer-motion"
import { detect } from "detect-browser"

// Styles
import * as styles from "./SearchPopover.module.scss"
import { SearchForm } from "../../components/Search/SearchForm"

const isIeBrowser = /(ie)/i.test(detect().name)

const SearchPopover = ({ children, closePopover }) => (
    <div className={styles.SearchPopover}>
        <div className={styles.back} onClick={closePopover}></div>

        <AnimatePresence>
            <motion.div initial={{ x: isIeBrowser ? 0 : -50 }} animate={{ x: 0 }} exit={{ x: 50 }} transition={{ duration: 0.4 }}>
                <SearchForm />
            </motion.div>
        </AnimatePresence>
    </div>
)

export default SearchPopover
